module.exports = __webpack_public_path__ + "static/assets/60a242014ff34890ed32b6ec2dfc8040.svg";